export default __webpack_public_path__ + "static/media/TTANewGirl.c5b8582e.svg";